import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAdressData, fetchTaxRegime } from '../../api/quoteApi';

export const getAdressData = createAsyncThunk(
  'contractor/getAdressData',
  async ({ zipCode }, { rejectWithValue }) => {
    try {
      const data = await fetchAdressData({ zipCode });

      if (!data || data.length === 0) return rejectWithValue("Código postal no encontrado");

      const colonias = data.colonias;
      const estado = data.estado;
      const municipio = data.municipio;

      return { estado, municipio, colonias };
    } catch (error) {
      return rejectWithValue(error.message || "Error al obtener datos del domicilio");
    }
  }
);

export const getFiscalAdressData = createAsyncThunk(
  'contractor/getFiscalAdressData',
  async ({ zipCode }, { rejectWithValue }) => {
    try {
      const data = await fetchAdressData({ zipCode });
      if (!data) return rejectWithValue("Código postal no encontrado");
      return {
        estado: data.estado,
        municipio: data.municipio,
        colonias: data.colonias,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTaxRegime = createAsyncThunk(
  'contractor/getTaxRegime',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchTaxRegime();

      if (!data) return rejectWithValue("Error al obtener datos del regimen fiscal");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {

  formValues: {
    primerApellido: '',
    segundoApellido: '',
    nombres: '',
    fechaNacimiento: '',
    genero: '',
    rfc: '',
    correoElectronico: '',
    telefonoMovil: '',
    telefonoFijo: '',
    extencion: '',
    esConductorHabitual: 'Si',
    codigoPostal: '',
    colonia: '',
    alcaldiaMunicipio: '',
    estadoRepublica: '',
    calle: '',
    numeroExterior: '',
    numeroInterior: '',
    regimenFiscal: '',
    esMismoDomicilioFiscal: 'Si',
    fiscalCodigoPostal: '',
    fiscalColonia: '',
    fiscalAlcaldiaMunicipio: '',
    fiscalEstadoRepublica: '',
    fiscalCalle: '',
    fiscalNumeroExterior: '',
    fiscalNumeroInterior: ''
  },

  validValues: {
    primerApellido: false,
    segundoApellido: false,
    nombres: false,
    fechaNacimiento: false,
    genero: false,
    rfc: false,
    correoElectronico: false,
    telefonoMovil: false,
    telefonoFijo: true,
    extencion: true,
    esConductorHabitual: false,
    codigoPostal: false,
    colonia: false,
    alcaldiaMunicipio: false,
    estadoRepublica: false,
    calle: false,
    numeroExterior: false,
    numeroInterior: true,
    regimenFiscal: true,
    esMismoDomicilioFiscal: false,
    fiscalCodigoPostal: false,
    fiscalColonia: false,
    fiscalAlcaldiaMunicipio: false,
    fiscalEstadoRepublica: false,
    fiscalCalle: false,
    fiscalNumeroExterior: false,
    fiscalNumeroInterior: true,
  },

  coloniasOptions: [],

  regimenFiscalOptions: [],

  coloniasOptionsFiscal: [],

  Error: null

};

const contractorSlice = createSlice({
  name: 'contractor',
  initialState,
  reducers: {
        setFormValue: (state, action) => {
            const { field, value } = action.payload;
            state.formValues[field] = value;
        },
        setValidValue: (state, action) => {
          const { field, isValid } = action.payload;
          state.validValues[field] = isValid;
        },
        resetFiscalFields: (state) => {
            state.formValues.fiscalEstadoRepublica = '';
            state.formValues.fiscalAlcaldiaMunicipio = '';
            state.formValues.fiscalColonia = '';
            state.coloniasOptionsFiscal = [];
        },
        resetError: (state) => {
            state.Error = null;
        },
        resetProcess: () => {
            return {
            ...initialState,
            };
        }
    },
    extraReducers: (builder) => {
    builder
      .addCase(getAdressData.fulfilled, (state, action) => {
        const { estado, municipio, colonias } = action.payload;
        state.formValues.estadoRepublica = estado;
        state.formValues.alcaldiaMunicipio = municipio;
        state.coloniasOptions = colonias;

        state.validValues.estadoRepublica = !!estado;
        state.validValues.alcaldiaMunicipio = !!municipio;
        state.validValues.codigoPostal = !!state.formValues.codigoPostal;
      })
      .addCase(getAdressData.rejected, (state, action) => {
        state.Error = action.payload || "Error al obtener datos del domicilio";
      })
      .addCase(getFiscalAdressData.fulfilled, (state, action) => {
        const { estado, municipio, colonias } = action.payload;
        state.formValues.fiscalEstadoRepublica = estado;
        state.formValues.fiscalAlcaldiaMunicipio = municipio;
        state.coloniasOptionsFiscal = colonias;

        state.validValues.fiscalEstadoRepublica = !!estado;
        state.validValues.fiscalAlcaldiaMunicipio = !!municipio;
        state.validValues.fiscalCodigoPostal = !!state.formValues.fiscalCodigoPostal;
      })
      .addCase(getTaxRegime.fulfilled, (state, action) => {
        state.regimenFiscalOptions = action.payload;
      })
      .addCase(getTaxRegime.rejected, (state, action) => {
        state.Error = action.payload || "Error al obtener los regímenes fiscales";
      });
  },
});

export const { 
  setFormValue,
  setValidValue,
  resetError,
  resetProcess,
  resetFiscalFields
} = contractorSlice.actions;
export default contractorSlice.reducer;